import $ from "jquery";
import { removeGroupSeparators } from "../utils/string.js";

function setupVisibleWhen(parentSelector) {
    let elements = $('[visible-when-target]');

    if (parentSelector) {
        elements = $(parentSelector).find('[visible-when-target]');
    }

    elements.each(function () {
        var name = $(this).attr("name") || $(this).attr("visible-when-name");
        var hidable = ($(this).is('div, fieldset') && !$(this).attr('visible-when-hide-row')) ? $(this) : $(this).parent().closest('div:not(.input-group), fieldset:not(.input-group)');
        var prefix = name.split('.').slice(0, -1);

        var targetName = $(this).attr("visible-when-target");
        targetName = prefix.concat(targetName).join('.');

        var adder = $(this).closest('[name="adderInputs"]');
        var target = $(`[name="${targetName}"]`);

        if (adder.Length) {
            target = adder.find(`[name="${targetName}"]`);
        }

        if (target.length == 0) {
            throw new Error(`Cannot find target ${targetName} for visible when with name ${name}`);
        }

        var comparator = $(this).attr("visible-when-comparator");
        var valuePropertyRaw = $(this).attr("visible-when-value-property");
        var valueProperty = null;
        var targetValues = null;
        var fieldsToMonitor = target;

        if (!valuePropertyRaw) {
            targetValues = JSON.parse($(this).attr("visible-when-values"));
        }
        else {
            let valuesName = prefix.concat(JSON.parse(valuePropertyRaw)).join('.');
            valueProperty = $(`[name="${valuesName}"]`);

            if (adder.Length) {
                valueProperty = adder.find(`[name="${valuesName}"]`);
            }

            fieldsToMonitor = target.add(valueProperty)
        }

        fieldsToMonitor
            .on(`change`, function () {
                setVisibleWhenVisibility(target, hidable, targetValues, comparator, valueProperty);
            });

        setVisibleWhenVisibility(target, hidable, targetValues, comparator, valueProperty);
    });
}

function setVisibleWhenVisibility(input, hidable, targetValues, comparator, valueProperty) {
    if (input.length > 1 && input.toArray().some(x => $(x).attr('type') == 'radio')) {
        input = input.filter((_, x) => $(x).is(':checked'));
    }

    var inputValue = input.is(':checkbox') ? input.is(':checked') : input.val();
    var hide = inputValue === '' || inputValue === undefined || hideVisibleWhenField(inputValue, targetValues, comparator, valueProperty);
    hidable.toggleClass('d-none', hide);

    hidable.children().find(':input:not([retain-value-on-hide])').each(function () {
        if (hide) {
            let change = false;

            if ($(this).attr('type') != 'radio') {
                var prevVal = $(this).val();
                $(this).val('');
                change = prevVal != $(this).val();
            } else {
                change = $(this).prop('checked');
                $(this).prop('checked', false);
            }

            if (change) {
                $(this).trigger('change');
            }
        }

        $(this).prop('disabled', hide);
    });

}

function hideVisibleWhenField(testValue, targetValues, comparator, valueProperty) {
    if (valueProperty) {
        targetValues = [parseFloat(removeGroupSeparators(valueProperty.val(), true) || 0)];
    }

    switch (comparator) {
        case "NotEqualTo":
            testValue = testValue.toString();
            return targetValues.includes(testValue === "True" || testValue === "False" ? testValue.toLowerCase() : testValue);
        case "EqualTo":
            testValue = testValue.toString();
            return !targetValues.includes(testValue === "True" || testValue === "False" ? testValue.toLowerCase() : testValue);
        case "LessThan":
            testValue = parseFloat(removeGroupSeparators(testValue, true) || 0)
            return targetValues.every((targetValue) => targetValue <= testValue);
        case "GreaterThan":
            testValue = parseFloat(removeGroupSeparators(testValue, true) || 0)
            return targetValues.every((targetValue) => targetValue >= testValue);
    }

    return false;
}

export default setupVisibleWhen;